import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { isNextDisabled, isPreviousDisabled, updateQueryCursor } from 'helpers';
import { Button } from 'components/ui/button';

const Pagination = ({ data, isFetching = false, limit = 60, setCursor = () => {} }) => {
  const [page, setPage] = useState(1);
  const totalPages = data ? Math.ceil(data.count / limit) : 1;

  const nextPage = () => {
    updateQueryCursor(data.next, setCursor);
    setPage((prevPage) => prevPage + 1);
  };

  const prevPage = () => {
    updateQueryCursor(data.previous, setCursor);
    setPage((prevPage) => prevPage - 1);
  };

  const isPaginationDisabled = isFetching || !data || data.count <= limit;

  return (
    <nav
      className="flex min-h-[61px] items-center justify-between gap-5 border-t border-[#e3e8e5] px-4 py-3 text-[11px] text-[#657269] max-[700px]:gap-2 max-[700px]:px-3"
      aria-label="Pagination"
    >
      <p className="whitespace-nowrap" aria-live="polite">
        Page <strong className="font-medium text-[#3d434a]">{page}</strong> sur{' '}
        <strong className="font-medium text-[#3d434a]">{totalPages || 1}</strong>
      </p>

      <div className="flex gap-[7px]">
        <Button
          variant="outline"
          className="h-[31px] rounded-md border-[#dce3de] px-2.5 text-[11px] text-[#3d434a] shadow-none hover:bg-[#f6f8f6]"
          disabled={isPaginationDisabled || isPreviousDisabled(data)}
          onClick={prevPage}
        >
          <ChevronLeft className="size-[13px] max-[700px]:hidden" aria-hidden="true" />
          Précédent
        </Button>

        <Button
          variant="outline"
          className="h-[31px] rounded-md border-[#dce3de] px-2.5 text-[11px] text-[#3d434a] shadow-none hover:bg-[#f6f8f6]"
          disabled={isPaginationDisabled || isNextDisabled(data)}
          onClick={nextPage}
        >
          Suivant
          <ChevronRight className="size-[13px] max-[700px]:hidden" aria-hidden="true" />
        </Button>
      </div>
    </nav>
  );
};

Pagination.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  isFetching: PropTypes.bool,
  limit: PropTypes.number,
  setCursor: PropTypes.func,
};

export default Pagination;
